export const AUTH_TRANSFER_READY = "AUTH_TRANSFER_READY";
export const AUTH_TRANSFER = "AUTH_TRANSFER";
export const AUTH_CLEARED = "AUTH_CLEARED";
export const IS_EMBEDDED = window !== window.parent;
export const TRANSFER_PARENT_PARAMS = "TRANSFER_PARENT_PARAMS";
